var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view form-view",attrs:{"id":"profile-view"}},[_c('h2',[_vm._v("User Profile")]),_c('v-layout',{attrs:{"row":""}},[_c('profile-settings',{attrs:{"form":_vm.formSettings,"handler":_vm.saveSettings}}),_c('profile-password',{attrs:{"form":_vm.formPassword,"handler":_vm.changePassword}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }